import { Button, Code, Group, Modal, Text, TextInput, Stack } from '@mantine/core';
import { useClipboard, useDisclosure } from '@mantine/hooks';
import { showSuccessNotification } from '../../../components/shared/notifications';

type IframeProps = {
  url: string;
};

export const Iframe = ({ url }: IframeProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { copy } = useClipboard();

  const handleCopy = () => {
    copy(url);
    showSuccessNotification({
      title: 'Copied to clipboard',
      message: 'You can now paste it wherever you need ✨📋',
    });
  };

  return (
    <>
      <Button variant='transparent' onClick={open}>
        {'< iframe >'}
      </Button>
      <Modal
        size='lg'
        centered
        opened={opened}
        onClose={close}
        title='Share Embed'
        styles={{
          title: {
            fontSize: '20px',
            fontWeight: 700,
          },
        }}
      >
        <Stack>
          <Text>You can access your model viewer through this link or ...</Text>
          <Group gap='xs'>
            <TextInput value={url} w='75%' />
            <Button w='20%' onClick={handleCopy}>
              Copy
            </Button>
          </Group>
          <Text>... use this code to embed the viewer on your website.</Text>
          <Code
            styles={{
              root: {
                padding: '15px',
              },
            }}
          >{`<iframe src="${url}"  frameborder="0"></iframe>`}</Code>
        </Stack>
      </Modal>
    </>
  );
};
